export default {
  title: 'Password',
  confirmPassword: {
    label: 'Confirm password',
    PasswordConfirmation: 'Your password and confirmation do not match.',
  },
};
